import React from "react";
import { Dialog } from "components/main/utils/Dialog";
import { Button } from "components/common/Button";

/// Cancellation takes effect at cycle end and the data stays readable.
export const CancelSubscriptionDialog: React.FC<{
  open: boolean;
  onClose: () => void;
  /// The end of the paid cycle, formatted; `null` when Paddle has not said.
  endsOn: string | null;
  /// Set only when what the org holds today exceeds the free tier, so the
  /// courtesy warning is never shown to someone it would not apply to (D58).
  overFreeLimit: { held: string; allowed: string } | null;
  busy: boolean;
  error: string | null;
  onConfirm: () => void;
}> = ({ open, onClose, endsOn, overFreeLimit, busy, error, onConfirm }) => (
  <Dialog
    open={open}
    onClose={onClose}
    title="Cancel subscription?"
    actions={
      <>
        <Button variant="secondary" size="sm" onClick={onClose}>
          Keep subscription
        </Button>
        <Button
          variant="destructive"
          size="sm"
          loading={busy}
          onClick={onConfirm}
          data-testid="confirm-cancel-subscription"
        >
          Cancel at end of cycle
        </Button>
      </>
    }
  >
    <div className="flex flex-col gap-2">
      <span className="text-fg-regular">
        {endsOn
          ? `Your plan stays exactly as it is until ${endsOn}, when it ends.`
          : "Your plan stays exactly as it is until the end of this cycle, when it ends."}
      </span>
      <span className="text-fg-muted-regular">
        Nothing is charged after that. Everything this organization has stored
        stays readable and exportable afterwards, and you can change your mind
        any time before then.
      </span>
      {overFreeLimit && (
        <span className="text-warning" data-testid="cancel-over-free-limit">
          {`Storage is ${overFreeLimit.held} and the free plan allows ` +
            `${overFreeLimit.allowed}, so afterwards this organization can read ` +
            `and export but not add data.`}
        </span>
      )}
      {error && (
        <span className="text-error" data-testid="billing-error">
          {error}
        </span>
      )}
    </div>
  </Dialog>
);
